import type { Tokens } from '../../../theming/types'
import { type AvatarProps } from '..'

export default (config: {
  props: Pick<AvatarProps, 'colorIndex' | 'shape'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  return {
    placeholder: {
      avatar: {
        backgroundColor:
          props.colorIndex === -1
            ? tokens.avatarBgColorSign
            : tokens.avatarBgColorPlaceholder,
        color: tokens.iconColorEmphasis,

        '& > svg': {
          borderRadius: 0,
          fill: tokens.iconColorEmphasis,
          height: '50%',
          width: '50%',
        },
      },
    },

    sizeXxlarge: {
      avatar: {
        fontSize: '20px',
        height: '48px',
        width: '48px',
      },
    },

    sizeXlarge: {
      avatar: {
        fontSize: '20px',
        height: '48px',
        width: '48px',
      },
    },

    sizeLarge: {
      avatar: {
        fontSize: '20px',
        height: '48px',
        width: '48px',
      },
    },

    sizeMedium: {
      avatar: {
        fontSize: '16px',
        height: '40px',
        width: '40px',
      },
    },

    sizeSmall: {
      avatar: {
        fontSize: '12px',
        height: '32px',
        width: '32px',
        borderRadius: props.shape === 'square' ? '2px' : '50%',
      },
    },

    sizeXsmall: {
      avatar: {
        fontSize: '10px',
        height: '24px',
        width: '24px',
        borderRadius: props.shape === 'square' ? '2px' : '50%',
      },
    },
  } as const
}
